import script from "./Add.vue?vue&type=script&setup=true&lang=js"
export * from "./Add.vue?vue&type=script&setup=true&lang=js"

import "./Add.vue?vue&type=style&index=0&id=d7cf32f0&scoped=true&lang=css"

import exportComponent from "/workspace/251623126/emo-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d7cf32f0"]])

export default __exports__